import { ReactNode } from 'react';
import { BUTTON_ACTION_TYPE } from '@app/components/UI/Button';
import ScFloatButton from '@app/components/UI/Button/FloatButton';

interface TabPanelProps {
    tabId: number;
    isActive: boolean;
    onSave: () => void;
    children: ReactNode;
}

/**
 * Wrapper cho mỗi tab panel – chứa content + nút Lưu
 */
const TabPanel = ({ tabId, isActive, onSave, children }: TabPanelProps) => (
    <div
        className={`tab-pane has-padding ${isActive ? 'active' : ''}`}
        id={`${tabId}`}
    >
        <div className="panel panel-flat">
            <div className="panel-body" style={{ display: 'block' }}>
                <div className="row">{children}</div>
                <div className="text-right">
                    <ScFloatButton
                        buttonType={BUTTON_ACTION_TYPE.SAVE}
                        labelButton="Lưu"
                        onClick={onSave}
                        hasAnimation
                    />
                </div>
            </div>
        </div>
    </div>
);

export default TabPanel;
